import { render, staticRenderFns } from "./MoreMessage.vue?vue&type=template&id=6c7a0bca&scoped=true";
import script from "./MoreMessage.vue?vue&type=script&lang=js";
export * from "./MoreMessage.vue?vue&type=script&lang=js";
import style0 from "./MoreMessage.vue?vue&type=style&index=0&id=6c7a0bca&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "6c7a0bca", null);
export default component.exports;